// Thrown by hooks/useFullPageLoadFor.js to abort a Next.js route change.
// Kept as a string, not an Error, so the Next.js dev overlay ignores it.
// Sentry also ignores it (see instrumentation-client.js).
export const TRACKING_NAVIGATION_ABORT =
  'Route change aborted: full page load to keep tracking scripts off this page'
